export default {"src":"/_next/static/media/8.be6ec361.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};